import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { PAYMENT_TERMS_MAPPING } from 'staticData/form';
import { PaymentsTermsIcon } from 'components/common/icons';
import { Col, EditableInfoComponent, Row, Typography } from 'components';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PaymentTermsEditModal } from 'feature/clientTabs/payments/paymentTerms/edit';
import { usePaymentTerms } from 'feature/clientTabs/payments/paymentTerms/usePaymentTerms';

const { Text } = Typography;

export const PaymentTerms = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { modalState, onModalStateChange, clientDetails, paymentMethod } = usePaymentTerms();
  return (
    <>
      <EditableInfoComponent
        title={'Payment Terms'}
        editable={hasAccess(PERMISSIONS.clients.payment_terms.write)}
        icon={<PaymentsTermsIcon />}
        onEdite={onModalStateChange}
      />
      <Row gutter={[0, 4]}>
        {clientDetails.paymentType && (
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Text type={'secondary'}>Payment terms</Text>
              </Col>
              <Col>
                <Text type={'secondary'}>
                  {PAYMENT_TERMS_MAPPING[clientDetails.paymentType as keyof typeof PAYMENT_TERMS_MAPPING]}
                </Text>
              </Col>
            </Row>
          </Col>
        )}
        {!!clientDetails.threshold && (
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Text type={'secondary'}>Threshold</Text>
              </Col>
              <Col>
                <Text type={'secondary'}>{clientDetails.threshold} €</Text>
              </Col>
            </Row>
          </Col>
        )}
        {!!clientDetails.prepayment && (
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Text type={'secondary'}>Prepayment</Text>
              </Col>
              <Col>
                <Text type={'secondary'}>{clientDetails.prepayment}%</Text>
              </Col>
            </Row>
          </Col>
        )}
        {!!clientDetails.postPayment && (
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Text type={'secondary'}>Post-payment</Text>
              </Col>
              <Col>
                <Text type={'secondary'}>{clientDetails.postPayment}%</Text>
              </Col>
            </Row>
          </Col>
        )}
        {paymentMethod?.name && (
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Text type={'secondary'}>Payment method</Text>
              </Col>
              <Col>
                <Text type={'secondary'}>{paymentMethod.name}</Text>
              </Col>
            </Row>
          </Col>
        )}
        {!!clientDetails.netDaysAfterDelivery && (
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Text type={'secondary'}>Net Days After Delivery</Text>
              </Col>
              <Col>
                <Text type={'secondary'}>
                  {clientDetails.netDaysAfterDelivery}
                  {clientDetails.netDaysAfterDelivery > 1 ? ' days' : ' day'}
                </Text>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
      <PaymentTermsEditModal
        modalState={modalState}
        onModalStateChange={onModalStateChange}
        dataToEdit={clientDetails}
      />
    </>
  );
});
